"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44202],{

/***/ 27200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);


/* eslint-disable react-hooks/exhaustive-deps */ 
var useGoalInfo = function(goalUID) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        selector: null,
        fallbackData: undefined
    };
    var key = "v1/topology/users/".concat(goalUID, "/self/");
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID ? key : null, {}, {
        fallbackData: options.fallbackData
    }), goalInfo = _ref.data, isValidating = _ref.isValidating, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") return options.selector(goalInfo || {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        key: key,
        goalInfo: goalInfo,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGoalInfo);


/***/ }),

/***/ 15509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39636);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93303);
/* harmony import */ var _icon_Close__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(112);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48821);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);








var fontGrey = "var(--color-text-primary)";
var StyledDrawer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Drawer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
    target: "eqzpp0y0",
    label: "StyledDrawer"
})("&.MuiDrawer-root > .MuiPaper-root{background-color:", function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor || "var(--color-base-0)";
}, ";display:grid;grid-template-columns:repeat(10,", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ");grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-auto-rows:max-content;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_12B */ .t8.SL, ";padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_6B */ .t8.BY, ";padding-right:115px;overflow-x:hidden;background-image:", function(param) {
    var $imageURL = param.$imageURL;
    return $imageURL && "url(".concat((0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_3__/* .getImage */ .gJ)($imageURL), ")");
}, ";background-position:", function(param) {
    var $imagePosition = param.$imagePosition;
    return $imagePosition;
}, ";background-repeat:no-repeat;background-size:", function(param) {
    var $imageSize = param.$imageSize;
    return $imageSize;
}, ";background-attachment:", function(param) {
    var $backgroundAttachment = param.$backgroundAttachment;
    return $backgroundAttachment;
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";overflow-x:initial;grid-template-columns:repeat(10,1fr);}", function(param) {
    var $login = param.$login, $hideCloseButton = param.$hideCloseButton;
    return !$hideCloseButton && "grid-template-rows: 60px ".concat($login ? "1fr" : "", ";");
}, "}");
var CloseWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eqzpp0y1",
    label: "CloseWrapper"
})("grid-column:1/11;cursor:pointer;@media (max-width:47.95em){grid-column:1/2;width:24px;height:24px;}");
var Drawer = function(param) {
    var children = param.children, anchor = param.anchor, backgroundColor = param.backgroundColor, drawerState = param.drawerState, onClose = param.onClose, hideCloseButton = param.hideCloseButton, showBackButton = param.showBackButton, elevation = param.elevation, onPressBack = param.onPressBack, imageURL = param.imageURL, imagePosition = param.imagePosition, imageSize = param.imageSize, backgroundAttachment = param.backgroundAttachment, disableBackdropClick = param.disableBackdropClick, disableEscapeKeyDown = param.disableEscapeKeyDown, login = param.login, variant = param.variant, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(StyledDrawer, {
        anchor: anchor,
        $backgroundColor: backgroundColor,
        open: drawerState,
        onClose: onClose,
        PaperProps: {
            id: "DrawerPaper"
        },
        $imageURL: imageURL,
        $imagePosition: imagePosition,
        $imageSize: imageSize,
        $backgroundAttachment: backgroundAttachment,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disableBackdropClick: disableBackdropClick,
        $login: login,
        $hideCloseButton: hideCloseButton,
        variant: variant,
        className: className,
        elevation: elevation,
        children: [
            !hideCloseButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_Close__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    size: "24px",
                    onClick: onClose,
                    color: fontGrey
                })
            }),
            showBackButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CloseWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    size: "24px",
                    onClick: onPressBack,
                    color: fontGrey
                })
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Drawer);
Drawer.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
            null
        ]),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node)
    ]),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    anchor: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOf([
        "left",
        "right",
        "top",
        "bottom"
    ]),
    drawerState: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired),
    hideCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    showBackButton: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    onPressBack: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    imageURL: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imagePosition: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    imageSize: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    backgroundAttachment: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    disableEscapeKeyDown: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    disableBackdropClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    login: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    elevation: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
Drawer.defaultProps = {
    children: null,
    backgroundColor: null,
    anchor: "right",
    drawerState: false,
    hideCloseButton: false,
    showBackButton: false,
    onPressBack: null,
    imageURL: null,
    imagePosition: null,
    imageSize: null,
    backgroundAttachment: null,
    elevation: 16,
    disableEscapeKeyDown: false,
    disableBackdropClick: false,
    login: false,
    variant: "temporary",
    className: ""
};


/***/ }),

/***/ 80867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);
/* harmony import */ var _cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65103);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18113);
/* harmony import */ var _utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72874);




/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-props-no-spreading */ 






/**
 * Extending styles (using @emotion/styled) will only
 * apply the styles to img element, but not to the outer image wrapper (div, next.js adds it) around it.
 *
 * So, can't add styles to the outer image wrapper.
 * Instead, we should create our own wrapper around it and apply styles to it.
 */ var StyledNextImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "e1pacfim0",
    label: "StyledNextImage"
})("-webkit-user-drag:none;user-select:none;");
var SourceImage = function(_param) {
    var src = _param.src, height = _param.height, width = _param.width, hasError = _param.hasError, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "src",
        "height",
        "width",
        "hasError"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!hasError) {
            (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .validateImage */ .ap)({
                src: src,
                width: width,
                height: height,
                type: "LEGACY"
            });
        }
    }, [
        hasError,
        height,
        src,
        width
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(StyledNextImage, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        height: height,
        width: width,
        src: src || _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .fillerImageURL */ .cE,
        loader: _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI
    }));
};
var Image = function(props) {
    return  true && (0,_utils_cookies__WEBPACK_IMPORTED_MODULE_5__/* .readCookie */ .vQ)(_utils_errorLogger__WEBPACK_IMPORTED_MODULE_6__/* .PROD_COOKIE_LOG_KEY */ .m) || "production" === "development" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_cont_ErrorBoundary_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        allowRender: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(SourceImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["default"] = (Image);


/***/ }),

/***/ 93303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var ArrowBack = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M66.9 37.5h-47.267l15.7-15.833c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0c-0.452-0.452-1.077-0.731-1.767-0.731s-1.314 0.279-1.767 0.731v0l-20 20.2c-0.433 0.424-0.702 1.015-0.702 1.668 0 0.035 0.001 0.069 0.002 0.103l-0-0.005c0.001 0.69 0.281 1.315 0.733 1.767v0l20.2 20c0.442 0.453 1.059 0.733 1.741 0.733 0.009 0 0.018-0 0.027-0h-0.001c1.365-0.020 2.465-1.131 2.465-2.5 0-0.69-0.279-1.315-0.731-1.767v0l-16-15.833h47.367c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5v0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowBack);


/***/ }),

/***/ 112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Close = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M43.533 40l21.567-21.567c0.416-0.445 0.671-1.045 0.671-1.704 0-1.381-1.119-2.5-2.5-2.5-0.659 0-1.259 0.255-1.706 0.672l0.001-0.001-21.567 21.567-21.567-21.567c-0.445-0.416-1.045-0.671-1.704-0.671-1.381 0-2.5 1.119-2.5 2.5 0 0.659 0.255 1.259 0.672 1.706l-0.001-0.001 21.567 21.567-21.567 21.567c-0.452 0.452-0.731 1.077-0.731 1.767s0.279 1.314 0.731 1.767v0c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0l21.567-21.567 21.567 21.567c0.452 0.452 1.077 0.731 1.767 0.731s1.314-0.279 1.767-0.731v0c0.452-0.452 0.731-1.077 0.731-1.767s-0.279-1.314-0.731-1.767v0z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Close);


/***/ }),

/***/ 57498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35415);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87936);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43605);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85690);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28119);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_hooks_goal_useGoalInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27200);
/* harmony import */ var aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92378);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44545);













var StyledDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e13239450",
    label: "StyledDiv"
})("grid-column:23/25;align-self:center;display:flex;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{grid-column:22/25;min-height:32px;height:32px;}", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{color:var(--color-i-green);background-color:transparent;height:14px;width:auto;grid-column:7/9;&:active{background-color:transparent;border:none;transform:none;}}");
var LoginCTAWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e13239451",
    label: "LoginCTAWrapper"
})("display:flex;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;justify-content:end;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";}");
var NewLoginCTA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    target: "e13239452",
    label: "NewLoginCTA"
})("padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj, ";width:104px;height:40px;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6 */ .t8.A1, ";font-weight:600;font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Fonts.ULTRA_SMALL */ .F3.tN, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM, ";white-space:nowrap;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_14 */ .t8.Be, ";height:32px;width:unset;min-width:64px;max-width:96px;}");
var NewStyleButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
    target: "e13239453",
    label: "NewStyleButton"
})("grid-column:23/25;align-self:center;display:flex;", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{grid-column:22/25;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj, ";min-width:unset;.button--label-content{font-weight:600;font-size:12px;line-height:16px;}}");
var acpfNudgeUrls = [
    "/goal/[goalSlug]/[goalUID]",
    "/goal/[goalSlug]/[goalUID]/home",
    "/goal/[goalSlug]/[goalUID]/subscriptions",
    "/goal/[goalSlug]/[goalUID]/success-story",
    "/goal/[goalSlug]/[goalUID]/store"
];
var Actions = function(param) {
    var isJoinForFreeCtaExperiment = param.isJoinForFreeCtaExperiment;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var isContentPage = (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith("/content/");
    var goalInfo = (0,_api_hooks_goal_useGoalInfo__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(isContentPage ? (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.goalUID : null).goalInfo;
    var route = router.route;
    var setInitialAccountType = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_10__/* .getSetInitialAccountType */ .IX);
    var ref2 = (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_5__/* .useToggleable */ .F7)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_DRAWER */ .es), openLoginDrawer = ref2.openElement;
    var login = function(e) {
        var ref;
        var ref1;
        _actions_analytics__WEBPACK_IMPORTED_MODULE_2__/* .segment.track */ .EX.track(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOGIN_STARTED */ .ke, {
            cta_button: (ref1 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.textContent) !== null && ref1 !== void 0 ? ref1 : ""
        });
        /**
     * If the login is clicked from any Content pages that is housed in Unacademy WEB,
     * we trigger this event.
     */ if (isContentPage && goalInfo) {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_2__/* .segment.track */ .EX.track("Content page - CTA clicked", {
                button_text: "Login",
                source_type: "content_pages",
                goal_name: goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.name,
                goal_uid: goalInfo === null || goalInfo === void 0 ? void 0 : goalInfo.uid
            });
        }
        openLoginDrawer();
    };
    var handleLogin = function(e) {
        setInitialAccountType(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ACCOUNT_TYPE_LOGIN */ .ZP.ACCOUNT_TYPE_LOGIN);
        login(e);
    };
    var handleSignup = function(e) {
        setInitialAccountType(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ACCOUNT_TYPE_SIGNUP */ .ZP.ACCOUNT_TYPE_SIGNUP);
        login(e);
    };
    if (isJoinForFreeCtaExperiment) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)(LoginCTAWrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(NewLoginCTA, {
                    onClick: handleLogin,
                    variant: "secondary",
                    children: "Log in"
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(NewLoginCTA, {
                    onClick: handleSignup,
                    children: "Join for free"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .Fragment */ .HY, {
        children: acpfNudgeUrls.includes(route) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(NewStyleButton, {
            onClick: handleLogin,
            children: "Log in"
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(StyledDiv, {
            label: "Log in",
            variant: "filled",
            onClick: handleLogin,
            grid: 2
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Actions);


/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15509);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85690);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28119);
/* harmony import */ var _base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28066);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2080);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _layout_Header_HeaderUser_HeaderUser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13024);
/* harmony import */ var _layout_Header_Actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57498);
/* harmony import */ var _comp_Logo_Logo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50648);
/* harmony import */ var _stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83995);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73060);
















var Login = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(52420), __webpack_require__.e(96523), __webpack_require__.e(9720), __webpack_require__.e(94336), __webpack_require__.e(56046), __webpack_require__.e(84079), __webpack_require__.e(98828)]).then(__webpack_require__.bind(__webpack_require__, 84079));
}, {
    ssr: false
});
var Header = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("header", {
    target: "etqhd6s0",
    label: "Header"
})("height:72px;width:100%;position:sticky;top:0;z-index:3;background:var(--color-base-1);box-shadow:", function(param) {
    var $hideHeaderShadow = param.$hideHeaderShadow;
    return !$hideHeaderShadow ? (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)() : "none";
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_5__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{box-shadow:inset 0px -1px 0px var(--color-shadow);display:block;width:100%;height:48px;}");
var Nav = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("nav", {
    target: "etqhd6s1",
    label: "Nav"
})("width:1136px;margin:auto;display:flex;align-items:center;justify-content:space-between;height:100%;", _styles_index__WEBPACK_IMPORTED_MODULE_5__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{width:728px;}", _styles_index__WEBPACK_IMPORTED_MODULE_5__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;padding:0 16px;}");
var StyledLogo = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_comp_Logo_Logo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    target: "etqhd6s2",
    label: "StyledLogo"
})("@media (max-width:47.95em){grid-column:1/2;}");
var RightContentWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "etqhd6s3",
    label: "RightContentWrapper"
})("display:flex;margin-left:auto;");
function HeaderComponent(param) {
    var className = param.className, showLogin = param.showLogin, hideHeaderShadow = param.hideHeaderShadow;
    var isMobile = (0,_stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__/* .useIsMobile */ .dD)();
    var ref = (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_3__/* .useToggleable */ .F7)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_12__/* .LOGIN_DRAWER */ .es), showLoginDrawer = ref.isOpen, closeLoginDrawer = ref.closeElement;
    var isLoggedIn = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_13__/* .getIsLoggedIn */ .M7);
    var onClose = function() {
        closeLoginDrawer();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Header, {
                className: className,
                $hideHeaderShadow: !!hideHeaderShadow,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(Nav, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(StyledLogo, {}),
                        isLoggedIn && !isMobile && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(RightContentWrapper, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_layout_Header_HeaderUser_HeaderUser__WEBPACK_IMPORTED_MODULE_7__["default"], {
                                excludeOptions: [
                                    "darkMode"
                                ]
                            })
                        }),
                        !isLoggedIn && showLogin && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_layout_Header_Actions__WEBPACK_IMPORTED_MODULE_8__["default"], {
                            showModal: true,
                            isJoinForFreeCtaExperiment: true
                        })
                    ]
                })
            }),
            showLogin && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(_base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                login: true,
                drawerState: showLoginDrawer,
                onClose: onClose,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(Login, {})
            })
        ]
    });
}
HeaderComponent.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().string),
    hideHeaderShadow: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().bool)
};
HeaderComponent.defaultProps = {
    className: "",
    hideHeaderShadow: false
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderComponent);


/***/ }),

/***/ 44545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loginStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/api/fetchers/config.js
var config = __webpack_require__(8989);
// EXTERNAL MODULE: ./src/api/fetchers/index.js
var fetchers = __webpack_require__(19982);
;// CONCATENATED MODULE: ./src/api/fetchers/login/index.js
/* eslint-disable import/prefer-default-export */ 

var login = function(param) {
    var email = param.email, phone = param.phone, otp = param.otp, countryCode = param.countryCode, backend = param.backend, firstName = param.firstName, lastName = param.lastName, state = param.state, password = param.password, register = param.register, _forClassroom = param.forClassroom, forClassroom = _forClassroom === void 0 ? false : _forClassroom, _code = param.code, code = _code === void 0 ? "" : _code, _ageGroupID = param.ageGroupID, ageGroupID = _ageGroupID === void 0 ? "" : _ageGroupID, accessToken = param.accessToken;
    return (0,fetchers/* default */.Z)("v1/user/login/?enable-email=true", {
        requestType: "POST",
        useAuthToken: false,
        useCamelCase: false,
        body: {
            backend: backend,
            phone: phone,
            otp: otp,
            access_token: accessToken,
            client_id: config/* default.apiClientId */.Z.apiClientId,
            client_secret: config/* default.apiClientSecret */.Z.apiClientSecret,
            country_code: countryCode,
            email: email,
            first_name: firstName,
            last_name: lastName,
            state: state,
            password: password,
            register: register,
            user_info: false,
            is_un_teach_user: forClassroom,
            un_teach_institue_code: code,
            country_age_group_uid: ageGroupID
        }
    });
};
var sendOtpOrEmail = function(param) {
    var _phone = param.phone, phone = _phone === void 0 ? "" : _phone, countryCode = param.countryCode, otpType = param.otpType, _email = param.email, email = _email === void 0 ? "" : _email, _forClassroom = param.forClassroom, forClassroom = _forClassroom === void 0 ? false : _forClassroom;
    return (0,fetchers/* default */.Z)("v3/user/user_check/?enable-email=true", {
        requestType: "POST",
        useAuthToken: false,
        useCamelCase: false,
        body: {
            phone: phone,
            country_code: countryCode,
            otp_type: otpType,
            email: email,
            send_otp: true,
            is_un_teach_user: forClassroom
        }
    });
};
var verifyPhone = function(param) {
    var phone = param.phone, countryCode = param.countryCode, otpType = param.otpType;
    return (0,fetchers/* default */.Z)("v1/user/me/verify_phone_otp/", {
        requestType: "POST",
        useCamelCase: false,
        body: {
            phone: phone,
            country_code: countryCode,
            otp_type: otpType
        }
    });
};

;// CONCATENATED MODULE: ./src/stores/login/loginStore.js




var useLoginStore = (0,esm/* default */.Z)(function(set) {
    return {
        initialAccountType: null,
        loggingIn: false,
        isSendingOtp: false,
        otpOrEmailData: null,
        loginResponse: null,
        verifyOtpResponse: {
            type: "phone",
            submitting: false,
            success: false,
            error: false,
            errorMsg: ""
        },
        isNewLoginModal: false,
        IsLoginModalExperiment: false,
        isLoginModalVariation: null,
        login: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var loginResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                loggingIn: true
                            });
                            _ctx.next = 3;
                            return login(body);
                        case 3:
                            loginResponse = _ctx.sent;
                            set({
                                loginResponse: loginResponse,
                                loggingIn: false
                            });
                            return _ctx.abrupt("return", loginResponse);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        sendOtpOrEmail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var otpOrEmailData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isSendingOtp: true
                            });
                            _ctx.next = 3;
                            return sendOtpOrEmail(body);
                        case 3:
                            otpOrEmailData = _ctx.sent;
                            set({
                                otpOrEmailData: otpOrEmailData,
                                isSendingOtp: false
                            });
                            return _ctx.abrupt("return", otpOrEmailData);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOtpResponse: function() {
            return set({
                otpOrEmailData: null
            });
        },
        verifyPhone: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(body) {
                var ref, verifyOtpResponse;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            set({
                                verifyOtpResponse: {
                                    type: "phone",
                                    submitting: true,
                                    success: false,
                                    error: false,
                                    errorMsg: ""
                                }
                            });
                            _ctx.next = 4;
                            return verifyPhone(body);
                        case 4:
                            verifyOtpResponse = _ctx.sent;
                            set({
                                verifyOtpResponse: {
                                    type: "phone",
                                    submitting: false,
                                    success: !(verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : verifyOtpResponse.error),
                                    error: !!(verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : verifyOtpResponse.error),
                                    errorMsg: (verifyOtpResponse === null || verifyOtpResponse === void 0 ? void 0 : (ref = verifyOtpResponse.error) === null || ref === void 0 ? void 0 : ref.message) || ""
                                }
                            });
                            return _ctx.abrupt("return", verifyOtpResponse);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(body) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetVerifyOtpResponse: function() {
            return set({
                verifyOtpResponse: null
            });
        },
        setLocalPhoneNumber: function(localPhoneNumber, localSelectedCountry) {
            return set({
                localPhoneNumber: localPhoneNumber,
                localSelectedCountry: localSelectedCountry
            });
        },
        setLocalEmailAndName: function(localEmail, localName) {
            return set({
                localEmail: localEmail,
                localName: localName
            });
        },
        setInitialAccountType: function(initialAccountType) {
            return set({
                initialAccountType: initialAccountType
            });
        },
        setIsNewLoginModal: function(isNewLoginModal) {
            return set({
                isNewLoginModal: isNewLoginModal
            });
        },
        setIsLoggingIn: function(loggingIn) {
            return set({
                loggingIn: loggingIn
            });
        },
        setIsLoginModalExperiment: function(IsLoginModalExperiment) {
            return set({
                IsLoginModalExperiment: IsLoginModalExperiment
            });
        },
        setIsLoginModalVariation: function(isLoginModalVariation) {
            return set({
                isLoginModalVariation: isLoginModalVariation
            });
        }
    };
});
/* harmony default export */ var loginStore = (useLoginStore);


/***/ }),

/***/ 98964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ getOtpOrEmailResponse; },
/* harmony export */   "$Q": function() { return /* binding */ getLocalName; },
/* harmony export */   "BD": function() { return /* binding */ getInitialAccountType; },
/* harmony export */   "Bt": function() { return /* binding */ getSetLocalPhoneNumber; },
/* harmony export */   "Ep": function() { return /* binding */ getIsPartialUser; },
/* harmony export */   "FQ": function() { return /* binding */ getLoginResponse; },
/* harmony export */   "IX": function() { return /* binding */ getSetInitialAccountType; },
/* harmony export */   "L": function() { return /* binding */ getIsLoggingIn; },
/* harmony export */   "Rw": function() { return /* binding */ getSetIsLoginModalVariation; },
/* harmony export */   "SE": function() { return /* binding */ getOTPSender; },
/* harmony export */   "Tj": function() { return /* binding */ getResetVerifyOtpResponse; },
/* harmony export */   "W4": function() { return /* binding */ getLocalPhoneNumber; },
/* harmony export */   "Yk": function() { return /* binding */ getSetLocalEmailAndName; },
/* harmony export */   "al": function() { return /* binding */ getIsLoginModalExperiment; },
/* harmony export */   "aw": function() { return /* binding */ getIsPhoneVerified; },
/* harmony export */   "bq": function() { return /* binding */ getLocalSelectedCountry; },
/* harmony export */   "eG": function() { return /* binding */ getIsRegistered; },
/* harmony export */   "gB": function() { return /* binding */ getPhoneVerifier; },
/* harmony export */   "jC": function() { return /* binding */ getLoginMethod; },
/* harmony export */   "k$": function() { return /* binding */ getLocalEmail; },
/* harmony export */   "lf": function() { return /* binding */ getSetIsLoginModalExperiment; },
/* harmony export */   "pK": function() { return /* binding */ getLoginAction; },
/* harmony export */   "qN": function() { return /* binding */ getSetIsNewLoginModal; },
/* harmony export */   "qw": function() { return /* binding */ getIsSendingOtp; },
/* harmony export */   "w8": function() { return /* binding */ getSetIsLoggingIn; },
/* harmony export */   "wM": function() { return /* binding */ getOTPDataCleaner; },
/* harmony export */   "wm": function() { return /* binding */ getIsLoginModalVariation; },
/* harmony export */   "zf": function() { return /* binding */ getIsNewLoginModal; }
/* harmony export */ });
var getLoginResponse = function(auth) {
    return auth.loginResponse;
};
var getIsLoggingIn = function(auth) {
    return auth.loggingIn;
};
var getIsSendingOtp = function(auth) {
    return auth.isSendingOtp;
};
var ref;
var getLoginMethod = function(auth) {
    var ref1;
    return (ref = (ref1 = auth.otpOrEmailData) === null || ref1 === void 0 ? void 0 : ref1.login_method) !== null && ref !== void 0 ? ref : false;
};
var getOtpOrEmailResponse = function(auth) {
    return auth.otpOrEmailData;
};
var ref1;
var getIsRegistered = function(auth) {
    var ref;
    return (ref1 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.is_registered) !== null && ref1 !== void 0 ? ref1 : false;
};
var getIsPartialUser = function(auth) {
    var ref;
    var ref1 = (auth === null || auth === void 0 ? void 0 : auth.otpOrEmailData) || {}, is_email_verified = ref1.is_email_verified, is_registered = ref1.is_registered, has_name = ref1.has_name;
    if (is_registered && (is_email_verified || has_name)) return false;
    var ref2;
    return (ref2 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.is_partial_user) !== null && ref2 !== void 0 ? ref2 : false;
};
var ref2;
var getIsPhoneVerified = function(auth) {
    var ref;
    return (ref2 = (ref = auth.otpOrEmailData) === null || ref === void 0 ? void 0 : ref.verify_phone) !== null && ref2 !== void 0 ? ref2 : false;
};
var getLocalPhoneNumber = function(auth) {
    return auth.localPhoneNumber;
};
var getLocalSelectedCountry = function(auth) {
    return auth.localSelectedCountry;
};
var getLocalEmail = function(auth) {
    return auth.localEmail;
};
var getLocalName = function(auth) {
    return auth.localName;
};
var getInitialAccountType = function(auth) {
    return auth.initialAccountType;
};
var getIsNewLoginModal = function(auth) {
    return auth.isNewLoginModal;
};
var getIsLoginModalExperiment = function(auth) {
    return auth.IsLoginModalExperiment;
};
var getIsLoginModalVariation = function(auth) {
    return auth.isLoginModalVariation;
};
// Setters and actions
var getLoginAction = function(auth) {
    return auth.login;
};
var getOTPSender = function(auth) {
    return auth.sendOtpOrEmail;
};
var getOTPDataCleaner = function(auth) {
    return auth.resetOtpResponse;
};
var getPhoneVerifier = function(auth) {
    return auth.verifyPhone;
};
var getResetVerifyOtpResponse = function(auth) {
    return auth.resetVerifyOtpResponse;
};
var getSetLocalPhoneNumber = function(auth) {
    return auth.setLocalPhoneNumber;
};
var getSetLocalEmailAndName = function(auth) {
    return auth.setLocalEmailAndName;
};
var getSetInitialAccountType = function(auth) {
    return auth.setInitialAccountType;
};
var getSetIsNewLoginModal = function(auth) {
    return auth.setIsNewLoginModal;
};
var getSetIsLoggingIn = function(auth) {
    return auth.setIsLoggingIn;
};
var getSetIsLoginModalExperiment = function(auth) {
    return auth.setIsLoginModalExperiment;
};
var getSetIsLoginModalVariation = function(auth) {
    return auth.setIsLoginModalVariation;
};


/***/ })

}]);